module.exports = __webpack_public_path__ + "static/media/Bushes_White.11858f5e.webp";